import React, { useEffect, useState } from 'react';
import NewApiKey from './NewApiKey';
import { clearFreshKey, peekFreshKey, subscribeFreshKey } from '../lib/freshKey';

/**
 * Paints the one-time API key reveal, from above the signed-in/signed-out
 * switch so it survives the remount that creating an account causes.
 *
 * Mounted once, at the app root. Renders nothing until a key is parked.
 * Deliberately has no backdrop dismiss and no close X: the value cannot be
 * recovered afterwards, so leaving needs the explicit button.
 */
export default function NewApiKeyGate() {
  const [apiKey, setApiKey] = useState(() => peekFreshKey());

  useEffect(() => subscribeFreshKey(() => setApiKey(peekFreshKey())), []);

  useEffect(() => {
    if (!apiKey) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, [apiKey]);

  if (!apiKey) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      data-testid="new-api-key-gate"
    >
      <div className="w-full max-w-[460px] bg-[var(--bg-2)] border border-[var(--border-2)] rounded-sm p-8">
        <NewApiKey apiKey={apiKey} onDone={clearFreshKey} doneLabel="I've saved it — continue" />
      </div>
    </div>
  );
}
